import {
	type AsyncIntlProviderComponent,
	createAsyncIntlProvider,
} from '@atlaskit/intl-messages-provider/async';

import messages from '../../../i18n/en';
import { asyncLanguages } from './async-languages';

export const AsyncIntlProvider: AsyncIntlProviderComponent = createAsyncIntlProvider({
	defaultMessages: messages,
	asyncLanguages,
});
